import _             from 'underscore';
import React, { FC } from 'react';
import { Label }     from 'semantic-ui-react';
import classNames    from 'classnames';

interface Props {
	padded?: boolean,
	error?: unknown | null | string
}

const defaultProps: Props = {
	padded: true,
	error:  null,
}

const FormArrayErrorContainer: FC<Props> = ( props ) => {
	
	let { error, children } = props,
	    hasErrorMessage     = ( typeof error == 'string' );
	
	return (
		<>
			{ hasErrorMessage &&
			<Label pointing='below' basic color={ 'red' }
			       content={ error }
			       className={ 'fade-in no-margin position--relative' }
			       style={ { top: -8 } }/>
			}
			
			<div className={ classNames( {
				'padding-sm':                     props.padded,
				'border-lg':                      hasErrorMessage,
				'border--colored-negative-value': hasErrorMessage,
				'container--rounded':             hasErrorMessage,
			} ) }>
				
				{ children }
			
			</div>
		</>
	);
};

FormArrayErrorContainer.defaultProps = defaultProps;

export { FormArrayErrorContainer }
